import router, { asyncRoutes, constantRoutes } from '@/router'
import store from '@/store'
import { getMenusService } from '@/api/menu'
import Vue from 'vue'
const getDefaultState = () => {
  // console.log(localStorage.getItem('showRouter'))
  return {
    asyncRoutesAdded: false,
    router: constantRoutes,
    addRouters: [],
    allRouters: [], // 接口返回的目录
    activeMenu: '',
    showRouter: localStorage.getItem('showRouter') ? JSON.parse(localStorage.getItem('showRouter')) : [], // 展示的router列表
    basePath: localStorage.getItem('basePath'),
    fromRouter: sessionStorage.getItem('fromRouter') ? JSON.parse(sessionStorage.getItem('fromRouter')) : null,
    fromRouterPath: sessionStorage.getItem('fromRouterPath') ? sessionStorage.getItem('fromRouterPath') : null,
    pageStack: sessionStorage.getItem('pageStack') ? JSON.parse(sessionStorage.getItem('pageStack')) : [],
    reloadKeepAliveTrrigger: true,
    selectMenuAuto: '',
    fisrtRouter: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_ASYNCROUTESADDED: (state, asyncRoutesAdded) => {
    state.asyncRoutesAdded = asyncRoutesAdded
  },
  SET_ROUTER: (state, router) => {
    state.router = router
  },
  SET_SHOW_ROUTER: (state, router) => {
    state.showRouter = router || []
    localStorage.setItem('showRouter', router ? JSON.stringify(router) : JSON.stringify([]))
  },
  SET_FIRST_ROUTER: (state, router) => {
    state.fisrtRouter = router || ''
  },
  SET_BASE_PATH: (state, basePath) => {
    state.basePath = basePath
    localStorage.setItem('basePath', basePath)
  },
  SET_ADD_ROUTE: (state, router) => {
    state.addRouters = router
    state.router = constantRoutes.concat(router)
  },
  SET_ALL_ROUTE: (state, router) => {
    state.allRouters = router
  },
  SET_FROM_ROUTE: (state, data) => {
    const change = state.fromRouterPath !== data.fromRouterPath
    state.fromRouter = data.fromRouter
    state.fromRouterPath = data.fromRouterPath
    if (data.fromRouter) {
      sessionStorage.setItem('fromRouter', JSON.stringify(data.fromRouter))
    } else {
      sessionStorage.removeItem('fromRouter')
    }

    if (data.fromRouterPath) {
      sessionStorage.setItem('fromRouterPath', data.fromRouterPath)
    } else {
      sessionStorage.removeItem('fromRouterPath')
    }
    if (change) {
      state.pageStack = []
      sessionStorage.removeItem('pageStack')
      state.reloadKeepAliveTrrigger = false
      Vue.nextTick(() => {
        state.reloadKeepAliveTrrigger = true
      })
    }
  },
  SET_PAGE_STACK: (state, data) => {
    const fromRouter = data.fromRouter
    const fromFullPath = data.fromFullPath
    let index = -1
    for (let i = 0; i < state.pageStack.length; i++) {
      const page = state.pageStack[i]
      if (page.id === fromRouter.id) {
        index = i
        break
      }
    }
    if (index === -1) {
      // 无记录，入栈
      const fromRouterCopy = JSON.parse(JSON.stringify(fromRouter))
      fromRouterCopy.fromFullPath = fromFullPath
      state.pageStack.push(fromRouterCopy)
      sessionStorage.setItem('pageStack', JSON.stringify(state.pageStack))
    } else if (index < state.pageStack.length - 1) {
      // 非栈顶，弹栈
      state.pageStack.splice(index + 1, state.pageStack.length - index - 1)
      sessionStorage.setItem('pageStack', JSON.stringify(state.pageStack))
    } else {
      // 栈顶 不处理
    }
  },
  SET_ACTIVE_MENU: (state, activeMenu) => {
    state.activeMenu = activeMenu
  },
  SET_SELECT_MENU_AUTO: (state, selectMenuAuto) => {
    state.selectMenuAuto = selectMenuAuto
  }
}
function hasPermission(authority, route) {
  if (!route.meta || route.meta.authority === undefined) {
    return true
  }
  return route.meta.authority >= authority
}
function recursiveRouterLeaf(router, parentPath, callback) {
  for (const r of router) {
    if (r.children && r.children.length > 0) {
      recursiveRouterLeaf(r.children, parentPath + '/' + r.path, callback)
    } else {
      callback(parentPath, r)
    }
  }
}
const actions = {
  setSelectMenuAuto({ commit }, selectMenuAuto) {
    commit('SET_SELECT_MENU_AUTO', selectMenuAuto)
  },
  setActiveMenu({ commit }, activeMenu) {
    commit('SET_ACTIVE_MENU', activeMenu)
  },
  reloadMainFrame({ commit }) {
    state.reloadKeepAliveTrrigger = false
    Vue.nextTick(() => {
      state.reloadKeepAliveTrrigger = true
    })
  },
  setFromRouter({ commit }, to) {
    const fromFullPath = to.fullPath
    let fromRouterPath = to.path
    fromRouterPath = fromRouterPath.split('?')[0]
    if (fromRouterPath === '/home') {
      commit('SET_FROM_ROUTE', { fromRouter: null, fromRouterPath: null })
    }
    // state.showRouter代表当前菜单及子页面，审核页等共用页面不在栈内记录
    recursiveRouterLeaf(state.showRouter, state.basePath, (parentPath, r) => {
      // debugger
      const isMenuPage = r.type !== 3
      const isCurrentPage = fromRouterPath === (parentPath + '/' + r.path)
      if (isMenuPage && isCurrentPage) {
        commit('SET_FROM_ROUTE', { fromRouter: r, fromRouterPath: fromRouterPath })
      }
      if (isCurrentPage) {
        commit('SET_PAGE_STACK', { fromRouter: r, fromRouterPath: fromRouterPath, fromFullPath: fromFullPath })
      }
    })
  },
  resetRouter({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_ASYNCROUTESADDED', false)
      commit('SET_ADD_ROUTE', [])
    })
  },
  setShowRouter({ commit }, router) {
    commit('SET_SHOW_ROUTER', router)
  },
  setFirstRouter({ commit }, router) {
    commit('SET_FIRST_ROUTER', router)
  },
  setBasePath({ commit }, basePath) {
    commit('SET_BASE_PATH', basePath)
  },
  routerAdd1({ commit }) {
    return new Promise((resolve, reject) => {
      const accessedRouters = asyncRoutes.filter(v => {
        if (hasPermission(store.getters.authority, v)) {
          if (v.children && v.children.length > 0) {
            v.children = v.children.filter(child => {
              if (hasPermission(store.getters.authority, child)) {
                return child
              }
              return false
            })
            return v
          } else {
            return v
          }
        }
        return false
      })
      router.addRoutes(accessedRouters)
      console.log('accessedRouters')
      console.log(accessedRouters)
      const routerList = []
      routerList.push(...constantRoutes)
      routerList.push(...accessedRouters)
      commit('SET_ASYNCROUTESADDED', true)
      commit('SET_ROUTER', routerList)
    })
  },
  GenerateRoutes({ commit }) {
    return new Promise((resolve, reject) => {
      if (store.getters.addRouters.length > 0) {
        resolve()
        commit('SET_ASYNCROUTESADDED', true)
      } else {
        getMenusService().then(data => {
          if (!data) {
            commit('SET_ASYNCROUTESADDED', true)
            resolve()
            return
          }
          commit('SET_ALL_ROUTE', data)
          const firstRoutes = data.filter(item => {
            return item.parentId === '' || item.parentId === null || item.parentId === 0
          })
          firstRoutes.sort((a, b) => a.sort - b.sort)
          let routes = []
          setMenus(firstRoutes, data, routes, true)
          console.log(routes)
          routes = routes.concat(asyncRoutes)
          commit('SET_ADD_ROUTE', routes)
          commit('SET_ASYNCROUTESADDED', true)
          resolve()
        }).catch(e => {
          commit('SET_ASYNCROUTESADDED', true)
          reject()
          console.log(e)
          console.log(' 列表请求出现异常')
        })
      }
    })
  }
}
function setMenus(firstRoutes, data, routes, isFirst) {
  firstRoutes.forEach(item => {
    if (item.id === null || item.id === undefined) {
      return
    }
    const obj = {
      ...item,
      path: item.path ? item.path.split('?')[0] : '',
      params: item.path ? item.path.split('?')[1] : '',
      // component: isFirst ? (item.module ? (resolve) => require([`@/views/${item.module}`], resolve) : () => import('@/layout')) : (resolve) => require([`@/views/${item.module}`], resolve),
      component: getComponent(item.module),
      name: item.routeName,
      funcName: item.funcName,
      meta: { title: item.metaTitle, icon: item.icon, type: item.type, keepAlive: item.keepAlive, activeMenu: item.activeMenu },
      isShowHome: item.isShowInHomePage
    }
    if (item.type === 3) {
      obj.hidden = true
    }
    const children = data.filter(menu => menu.parentId === item.id)
    children.sort((a, b) => a.sort - b.sort)
    if (children.length > 0) {
      obj.children = []
      setMenus(children, data, obj.children)
    }
    routes.push(obj)
  })
}
function getComponent(module) {
  if (module) {
    if (module.includes('layout')) {
      return () => import('@/layout')
    } else if (module.includes('view')) {
      const index1 = module.indexOf('views')
      const index2 = module.indexOf('view')
      const str = module.substring((index1 > -1 ? (index1 + 1) : index2) + 5)
      return (resolve) => require([`@/views/${str}`], resolve)
    }
  }
  return {
    render(c) { return c('router-view') }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

